import ReactPaginate from "react-paginate";
import { useQueryParams } from "@madkom/query-params";
import styled from "@emotion/styled";
import { useColorModeValue } from "@chakra-ui/react";
import { GrNext, GrPrevious } from "react-icons/all";

import { Icon } from "../Icon";
import { useGetThemeColors } from "../../ChakraTheme";

interface IProps {
  limit: number;
  total: number;
}

const Pagination = ({ limit, total }: IProps) => {
  const { params, pages: pagesHelper } = useQueryParams<{ offset: number }>();
  const colors = useGetThemeColors();
  const activePageColor = useColorModeValue(
    colors.primary[600],
    colors.primary[900]
  );

  const hoverPageColor = useColorModeValue(colors.gray[300], colors.gray[200]);

  const { total: totalPages, change, current } = pagesHelper({
    limit: limit,
    offset: params.offset ?? 0,
    total,
  });
    return (
        <PagesContainer
            activePageColor={activePageColor}
            hoverPageColor={hoverPageColor}
        >
            <ReactPaginate
                forcePage={current - 1}
                initialPage={current - 1}
                previousLabel={<Icon icon={GrPrevious} />}
                nextLabel={<Icon icon={GrNext} />}
                breakLabel={"..."}
                pageCount={totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={2}
                onPageChange={(data: { selected: number }) => {
                    change(data.selected + 1);
                }}
                containerClassName={"pagination"}
                activeClassName={"active"}
                pageLinkClassName={"pageElement"}
                disableInitialCallback={true}
            />
        </PagesContainer>
    );
};

const PagesContainer = styled.div<{
  activePageColor: string;
  hoverPageColor: string;
}>`
  display: flex;
  justify-content: center;

  .pagination {
    width: fit-content;
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;

    li a {
      outline: none;
    }

    li:not([class="active"]) .pageElement:hover {
      background: ${(props) => props.hoverPageColor};
      color: black;
    }

    .active a {
      background: ${(props) => props.activePageColor};
      color: white;
      outline: initial;
    }

    .previous {
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }

    .previous:hover {
      background: ${(props) => props.hoverPageColor};
      color: black;
    }

    .next {
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }

    .next:hover {
      background: ${(props) => props.hoverPageColor};
      color: black;
    }

    li {
      margin: 0 0 0 -1px;
      border: 1px solid gray;
      word-break: keep-all;

      a {
        display: inline-block;
        text-decoration: none;
        border: none;
        width: 40px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        line-height: 40px;
        position: relative;
        cursor: pointer;
        font-size: 0.875em;
        color: black;

        &:disabled {
          cursor: not-allowed;
          opacity: 0.6;
        }

        &:focus {
          z-index: 1;
        }

        &:first-child {
          border-top-left-radius: 1px;
          border-bottom-left-radius: 1px;
        }

        &:last-child {
          border-top-right-radius: 1px;
          border-bottom-right-radius: 1px;
        }
      }
    }
  }
`;

export { Pagination };
